 interface Payout {
  country?: string;
  card?: {
    country?: {
      rates: any;
    };
    rates: Array<{
      range: {
        min: number;
        max: number;
      };
      type: string;
      rate: number;
    }>;
  };
  tradeValue: Array<{
    range: {
      min: number;
      max: number;
    };
    amount: number;
  }>;
  type: string;
}

const getOrdinalSuffix = (day: number): string => {
  if (day > 3 && day < 21) return 'th'; // Handle special cases like 11th, 12th, 13th
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

export const formatDateWithSuffix = (isoDateString: string): string => {
  const date = new Date(isoDateString);
  const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
  
  return `${month} ${day}${getOrdinalSuffix(day)}, ${year}`;
};

export const formatFullTimestamp = (isoDateString: string): string => {
  if (!isoDateString) return "—";
  const date = new Date(isoDateString);
  return date.toLocaleString("en-US", {
    dateStyle: "medium",
    timeStyle: "medium",
  });
};

export function formatAmount(value: any) {
  if (value === null || value === undefined) return "0.00"; // Handle null/undefined values

  const numValue = Number(value); // Convert to a number

  // Return '0.00' for zero value
  if (numValue === 0) return "0.00";

  // For values >= 0.01, format with 2 decimal places
  if (numValue >= 0.01) {
    return numValue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 3,
    });
  }

  // For small values < 0.01, handle with higher precision (up to 8 decimals)
  const precision = Math.abs(numValue) < 0.0001 ? 9 :  6; // Use 6 or 8 decimals based on magnitude
  return numValue.toLocaleString("en-US", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
}

  export const formatCurrency = (currencyString: string): string => {
  // Extract the currency code (first 3 characters) and the amount (remaining part)
  const amountString = currencyString?.slice(3);

  // Convert the amount string to a number and round it
  const amount = Math.ceil(Number(amountString));

  // Return the formatted currency with a space between the code and the amount
  return `₦ ${amount.toLocaleString()}`;
};

 

export const calculateGiftcardAmount = (payout: Payout): number => {
  let totalAmount = 0;

  const calculateAmount = (trade: { range: any; amount: number }, rate: number) => {
    const amount = trade.amount * rate;
    totalAmount += amount;
  };

  if (payout.country) {
    if (payout.card && payout.tradeValue && Array.isArray(payout.tradeValue)) {
      payout.tradeValue.forEach((trade) => {
        const { range } = trade;
        const rateInfo = payout.card?.rates.find(
          (r) =>
            r.range.min <= range.min &&
            r.range.max >= range.max &&
            r.type === payout.type
        );
        if (rateInfo) {
          calculateAmount(trade, rateInfo.rate);
        }
      });
    }
  } else {
    if (payout.card && payout.tradeValue && Array.isArray(payout.tradeValue)) {
      payout.tradeValue.forEach((trade) => {
        const { range } = trade;
        let rate = 0;

        const getRate = (type: string) => {
          return payout.card?.country?.rates[type]?.find(
            (r: { range: { min: number; max: number } }) =>
              r.range.min <= range.min && r.range.max >= range.max
          )?.rate;
        };

        switch (payout.type) {
          case "physicalActivationReceipt":
            rate = getRate("physicalActivationReceipt");
            break;
          case "physicalCashReceipt":
            rate = getRate("physicalCashReceipt");
            break;
          case "physicalCreditCardReceipt":
            rate = getRate("physicalCreditCardReceipt");
            break;
          case "physicalDebitCardReceipt":
            rate = getRate("physicalDebitCardReceipt");
            break;
          case "physicalNoReceipt":
            rate =
              getRate("physicalNoReceipt") ?? getRate("physicalNoreceipt");
            break;
          case "ecode":
            rate = getRate("ecode");
            break;
          default:
            break;
        }

        if (rate) {
          calculateAmount(trade, rate);
        }
      });
    }
  }

  return totalAmount;
};

